const translations = {
  en: {
    trackYour: 'Track your',
    withdrawal: 'Withdrawal',
    trackDescription: 'Once your withdrawal request has been registered, you can easily track the status of it, by clicking in the hand',
    accountId: 'Account ID:',
    balance: 'Balance:',
    payouts: 'Payouts:',
    pending: 'Pending',
  },
  es: {
    trackYour: 'Rastrear su',
    withdrawal: 'Retiro',
    trackDescription: 'Una vez que su solicitud de retiro haya sido registrada, puede rastrear fácilmente su estado haciendo clic en la mano',
    accountId: 'ID de Cuenta:',
    balance: 'Saldo:',
    payouts: 'Retiros:',
    pending: 'Pendiente',
  },
  pt: {
    trackYour: 'Rastrear seu',
    withdrawal: 'Saque',
    trackDescription: 'Uma vez que sua solicitação de saque tenha sido registrada, você pode rastrear facilmente o status clicando na mão',
    accountId: 'ID da Conta:',
    balance: 'Saldo:',
    payouts: 'Saques:',
    pending: 'Pendente',
  },
}

export default translations
